import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const params = {},
    actions = {
        signInAsUser: {
            url: `${BASE_PATH_API}/authentication/users/:userId/signIn`,
            method: 'POST'
        },
        logout: {
            url: `${BASE_PATH_API}/authentication/logout`,
            method: 'POST'
        },
        getCurrentUserInfo: {
            url: `${BASE_PATH_API}/authentication/getcurrentuser`,
            method: 'GET'
        },
        getTokenValidation: {
            method: 'POST',
            url: `${BASE_PATH_API}/v3/auth/managerToken/validate`
        },
        signInWithToken: {
            method: 'POST',
            url: `${BASE_PATH_API}/authentication/login/token`
        }
    };

export function AuthenticationApi() {
    return createActions(actions, params);
}
